import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GenericBoxComponent } from './generic-box.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    GenericBoxComponent
  ],
  exports: [GenericBoxComponent]
})
export class GenericBoxModule { }


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/drags/generic-box/generic-box.module.ts